/***
 *
 *   APP NAV
 *   Primary navigation used inside the main app component
 *
 *   PROPS
 *   type: fixed or popup (style of nav on mobile)
 *   items: array of objects containing label, link and icon (optional)
 *
 **********/

import { Button, Icon } from "components/lib";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./app.scss";
import logo from "./images/SmallLogo.png";

export function AppNav(props) {
  // state
  const [open, setOpen] = useState(false); // mobile is open
  const [expanded, setExpanded] = useState(true); // desktop is expanded

  return (
    <nav
      className={`sidebar popup expanded`}
      onMouseEnter={(e) => setExpanded(true)}
      onMouseLeave={(e) => {
        setExpanded(false);
        setOpen(false);
      }}
    >
      <Button
        icon={open ? "x" : "menu"}
        color={"dark"}
        size={12}
        className="btn-togglenav"
        action={(e) => setOpen(!open)}
      />

      <div
        style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}
      >
        <img src={logo} style={{ width: 80, marginTop: 10 }} />
      </div>
      <section className="nav-links">
        <main>
          {props.items?.map((item) => {
            if (item.link) {
              return (
                <NavLink
                  key={item.label}
                  to={item.link}
                  style={{ width: 100 / props.items.length + "%" }}
                >
                  {item.icon && (
                    <Icon
                      className="icon"
                      image={item.icon}
                      size={open ? 15 : 18}
                      color={open ? "dark" : "light"}
                    />
                  )}
                  {item.label && <span className="label">{item.label}</span>}
                </NavLink>
              );
            }

            return (
              <div key={item.label} onClick={item.action}>
                {item.icon && (
                  <Icon
                    className="icon"
                    image={item.icon}
                    size={open ? 15 : 18}
                    color={open ? "dark" : "light"}
                  />
                )}
                {item.label && <span className="label">{item.label}</span>}
              </div>
            );
          })}
        </main>
        <main style={{ marginBottom: 40 }}>
          {props.fixedItems?.map((item) => {
            if (item.link) {
              return (
                <NavLink
                  key={item.label}
                  to={item.link}
                  style={{ width: 100 / props.items.length + "%" }}
                >
                  {item.icon && (
                    <Icon
                      className="icon"
                      image={item.icon}
                      size={open ? 15 : 18}
                      color={open ? "dark" : "light"}
                    />
                  )}
                  {item.label && <span className="label">{item.label}</span>}
                </NavLink>
              );
            }

            return (
              <div key={item.label} onClick={item.action}>
                {item.icon && (
                  <Icon
                    className="icon"
                    image={item.icon}
                    size={open ? 15 : 18}
                    color={open ? "dark" : "light"}
                  />
                )}
                {item.label && <span className="label">{item.label}</span>}
              </div>
            );
          })}
        </main>
      </section>
    </nav>
  );
}
